<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="80%" :visible.sync="viewData.visible">
    <el-tabs ref="tabPanel">
        <el-tab-pane :key="1" label="基础信息" class="tab_style">
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border>

                      <el-descriptions-item label="子公司" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item style="margin-bottom: 0;" prop="bukrs">
                          <span v-if="viewFlag === 'view'">{{ getSubcompanyName(dataForm.bukrs) }}</span>
                          <el-select
                              v-else
                              v-model="dataForm.bukrs"
                              placeholder="请选择子公司"
                              clearable
                              @change="handleSubcompanyChange"
                              :disabled="viewFlag === 'view'"
                          >
                            <el-option
                                v-for="item in subcompanyList"
                                :key="item.value || 'empty_key_' + item.label"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-descriptions-item>

                        <el-descriptions-item label="ASN编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="asncode">
                                <span>{{dataForm.asncode}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="ASN状态" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="asnStatus">
                                <span>{{getAsnStatusByValue(dataForm.asnStatus)}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组代码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" >
                                <!-- <el-input v-show="false" v-model="dataForm.supplierId"></el-input> -->
                                <span>{{dataForm.groupCode}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="groupCode" style="margin-bottom: 0;">
                                <span v-if="viewFlag !== 'edit' || this.dataForm.asnStatus === '1' || (this.dataForm.asnStatus === '2' && this.dataForm.syncStatus != '3') || this.dataForm.asnStatus === '4'">{{dataForm.groupName}}</span>
                                <el-select style="width: 220px" v-else v-model="dataForm.groupCode" filterable placeholder="请选择采购组" :disabled="!dataForm.bukrs">
                                    <el-option v-for="item in groupList"
                                               :key="item.value || 'empty_group_' + item.label"
                                               :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="发货日期" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="deliveryDate">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' ||  (this.dataForm.asnStatus === '2' && this.dataForm.syncStatus != '3') || this.dataForm.asnStatus === '4'">
                                    {{ dateFormatValue(dataForm.deliveryDate) }}
                                </span>
                                <el-date-picker v-else v-model="dataForm.deliveryDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期" :picker-options="recievePicker">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="到货日期" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="recieveyDate">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || (this.dataForm.asnStatus === '2' && this.dataForm.syncStatus != '3') || this.dataForm.asnStatus === '4'">
                                    {{ dateFormatValue(dataForm.recieveyDate) }}
                                </span>
                                <el-date-picker v-else v-model="dataForm.recieveyDate" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期" :picker-options="recievePicker">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item v-if="isAuth('sourcing:sgwl:button')" label="供应商选择" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supplierCode" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || (this.dataForm.asnStatus === '2' && this.dataForm.syncStatus != '3') || this.dataForm.asnStatus === '4'">{{dataForm.supplierName}}</span>
                                <el-select @change="getAddressListByCode" v-else v-model="dataForm.supplierCode" filterable=true placeholder="请选择供应商">
                                    <el-option v-for="item in supplierList" :key="item.supplierCode" :label="item.supplierName" :value="item.supplierCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="收货地址" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="deliveryAddress" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || (this.dataForm.asnStatus === '2' && this.dataForm.syncStatus != '3') || this.dataForm.asnStatus === '4'">{{dataForm.deliveryAddress}}</span>
                                <el-select v-else v-model="dataForm.deliveryAddress" allow-create=true filterable=true placeholder="请选择地址" :disabled="!dataForm.bukrs">
                                    <el-option v-for="item in streetList" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="内向交货单" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="innerCode">
                                <span>{{dataForm.innerCode}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="备注" :label-style="getStyle()" style="">
                            <el-form-item style="margin-bottom: 0;" prop="remark">
                                <span v-if="viewFlag === 'view' || this.dataForm.asnStatus === '1' || (this.dataForm.asnStatus === '2' && this.dataForm.syncStatus != '3') || this.dataForm.asnStatus === '4'">{{dataForm.remark}}</span>
                                <el-input v-else type="textarea" :rows="3" size="small" v-model="dataForm.remark" placeholder="" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>

                </div>
                <el-row :gutter="10">
                    <el-col :span="24" style="padding: 15px">
                        <div>
                            注：1.送货单需保存两联； 2.签字栏必须是签字，不可盖章。
                        </div>
                        <hr />
                        <div style="line-height: 1.5;">
                            送货单流程：<br />
                            1. 供应商生成四联送货单，签字完成<br />
                            2. 司机带上四联送货单<br />
                            3.
                            到达到货地点，厂内物流验货完成填写实收数量，并签字确认，司机确认收货数量并签字<br />
                            4.
                            厂内物流保存第2，3联；第1、4联由司机带走，返回供应商<br />
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :key="2" label="明细信息" class="tab_style">
            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="float: right;" v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'">
                        <!-- <el-button plain v-if="isAuth('sourcing:delivery:newbutton')" :loading="handleSaveLoading" @click="handleSave()" icon='el-icon-edit' size='small' type="primary" :disabled="!dataForm.id">
                            保存物料信息
                        </el-button> -->
                        <el-button plain size="small" v-if="isAuth('sourcing:delivery:newbutton') && !dataForm.autoGenerate" type="primary" @click="selectPartList()" icon="el-icon-plus" :disabled="!dataForm.id || (dataForm.asnStatus === '1' || dataForm.asnStatus == '4') || (dataForm.asnStatus == '2' && dataForm.syncStatus == '2') " class="mb15">
                            选择物料信息
                        </el-button>
                    </div>
                    <span style="color: red;font-size: 12px;float:left;line-height: 30px;margin-right: 20px;" v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'">* 双击表格进行编辑</span>
                    <span style="color: red;font-size: 12px;float:left;line-height: 30px;margin-right: 20px;" v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'">* 同一物料号 请不要维护相同批次</span>
                    <el-table-edit v-loading="handleSaveLoading" :model="deviveryPartList" :columns="['orderCode','partCode','partName','containerCode','boxType','inCount','deliveredBoxCount','deliveredCount','unit','lichn','expressCompany','expressNo','remainingStock','recieveCount','returnCount','remark']" ref="editTable">
                        <el-table :data="deviveryPartList" row-key="id" size="small" border :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" @cell-dblclick="editAll" style="width: 100%">
                            <el-table-column type="index" width="50" label="序号">
                                <template slot-scope="scope">
                                    <span>{{ ((pageIndex - 1) * pageSize) + scope.$index + 1}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="zexpos" header-align="center" align="right" label="ASN行项" width="80">
<!--                                <template slot-scope="scope">-->
<!--                                    <span>{{scope.row.index = ((pageIndex - 1) * pageSize) + scope.$index + 1}}</span>-->
<!--                                </template>-->
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <!-- <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="150">
                            </el-table-column> -->
                            <!-- <el-table-column prop="asncode" header-align="center" align="left" label="ASN编码">
                        </el-table-column> -->
                            <!-- 供应商填写 -->
                            <el-table-column prop="partCode" header-align="center" align="left" label="物料号" width="120">
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="partName" header-align="center" align="left" label="物料名称" width="150">
                            </el-table-column>
                            <el-table-column prop="count" header-align="center" align="center" label="订单数量" width="80">
                            </el-table-column>
                            <el-table-column prop="asnRemaining" header-align="center" align="center" label="ASN剩余交货数量" width="120">
                            </el-table-column>
                            <!-- 交货数量 -->
                          <el-table-column prop="lfimg" header-align="center" align="center" width="100">
                            <template slot="header" slot-scope="scope">
                              <span style="color: red">*</span>交货数量
                            </template>
                            <template slot-scope="scope">
                              <ctl-number
                                  v-if="scope.row.show && !dataForm.autoGenerate"
                                  v-model="scope.row.lfimg"
                                  placeholder="交货数量"
                                  @change="calculateDeliveredBoxCount(scope.row)">
                              </ctl-number>
                              <span v-else>{{scope.row.lfimg}}</span>
                            </template>
                          </el-table-column>
                            <!-- 入库数量（原实收数量） 不可编辑 -->
                            <el-table-column prop="recieveCount" header-align="center" align="right" label="入库数量" width="80">
                            </el-table-column>
                            <!-- 退货数量 不可编辑 -->
                            <el-table-column prop="returnCount" header-align="center" align="right" label="退货数量" width="80">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.returnCount || 0 }}</span>
                                </template>
                            </el-table-column>
                            <!-- 实收数量 = 入库 - 退货 不可编辑 -->
                            <el-table-column header-align="center" align="right" label="实收数量" width="80">
                                <template slot-scope="scope">
                                    <span>{{ (scope.row.recieveCount || 0) - (scope.row.returnCount || 0) }}</span>
                                </template>
                            </el-table-column>
                            <!-- 单位 -->
                            <el-table-column prop="unit" header-align="center" align="center" label="单位" width="60">
                                <template slot-scope="scope">
                                    <span>{{getUnitName(scope.row.unit)}}</span>
                                </template>
                            </el-table-column>
                            <!-- 器具编码 不可编辑 -->
                            <el-table-column prop="containerCode" header-align="center" align="left" label="器具编码" width="120">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.containerCode }}</span>
                                </template>
                            </el-table-column>
                            <!-- 器具名称（原箱种） 条件可编辑 -->
                            <el-table-column prop="boxType" header-align="center" align="center" width="120">
                                <template slot="header" slot-scope="scope">
                                    <span>器具名称</span>
                                </template>
                                <template slot-scope="scope">
                                    <!-- 可编辑：手工生成 + 无专用器具 → 下拉选择 -->
                                    <el-select size="small" v-if="scope.row.show && !dataForm.autoGenerate && !scope.row.containerCode" v-model="scope.row.boxType" placeholder="选择器具" clearable filterable>
                                        <el-option
                                            v-for="item in applianceTypeList"
                                            :key="item.id || item.name"
                                            :label="item.name"
                                            :value="item.name">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{ scope.row.boxType }}</span>
                                </template>
                            </el-table-column>
                            <!-- 收容数 条件可编辑 -->
                          <el-table-column prop="inCount" header-align="center" align="right" width="80">
                            <template slot="header" slot-scope="scope">
                              <span>收容数</span>
                            </template>
                            <template slot-scope="scope">
                              <ctl-number
                                  v-if="scope.row.show && !dataForm.autoGenerate && !scope.row.containerCode"
                                  v-model="scope.row.inCount"
                                  placeholder="收容数"
                                  @change="calculateDeliveredBoxCount(scope.row)">
                              </ctl-number>
                              <span v-else>{{ scope.row.inCount }}</span>
                            </template>
                          </el-table-column>
                            <!-- 箱数/器具数 -->
                          <el-table-column prop="deliveredBoxCount" header-align="center" align="right" width="100">
                            <template slot="header" slot-scope="scope">
                              <span>箱数/器具数</span>
                            </template>
                            <template slot-scope="scope">
                              <ctl-number
                                  v-if="scope.row.show"
                                  v-model="scope.row.deliveredBoxCount"
                                  placeholder="箱数/器具数"
                                  :disabled="true">
                              </ctl-number>
                              <span v-else>{{ scope.row.deliveredBoxCount }}</span>
                            </template>
                          </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="hsdat" header-align="center" align="center" width="140">
                                <template slot="header" slot-scope="scope">
                                    <span style="color: red">*</span>生产日期
                                </template>
                                <template slot-scope="scope">
                                    <el-date-picker size="small" v-if="scope.row.show && !dataForm.autoGenerate" v-model="scope.row.hsdat" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{ dateFormatValue(scope.row.hsdat) }}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <el-table-column prop="vfdat" header-align="center" align="center" label="货架到期寿命" width="140">
                                <template slot-scope="scope">
                                    <el-date-picker size="small" v-if="scope.row.show && !dataForm.autoGenerate" v-model="scope.row.vfdat" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{ dateFormatValue(scope.row.vfdat) }}</span>
                                </template>
                            </el-table-column>
                            <!-- 供应商填写 -->
                            <!-- <el-table-column prop="lichn" header-align="center" align="left" label="供应商批次编号" width="150">
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show" v-model="scope.row.lichn" placeholder="供应商批次编号"></el-input>
                                    <span v-else>{{scope.row.lichn}}</span>
                                </template>
                            </el-table-column> -->
                            <!-- 供应商填写 -->
                            <!-- <el-table-column prop="deliveredCount" header-align="center" align="right" label="送货数量" width="151">
                                <template slot-scope="scope">
                                    <el-input-number :min="0" :max="999" size="small" v-if="scope.row.show" v-model="scope.row.deliveredCount" placeholder="送货数量"></el-input-number>
                                    <span v-else>{{scope.row.deliveredCount}}</span>
                                </template>
                            </el-table-column> -->
                            <!-- 供应商选填（生产批次） -->
                            <el-table-column prop="lichn" header-align="center" align="left" width="150">
                                <template slot="header" slot-scope="scope">
                                    <span style="color: red">*</span>生产批次
                                </template>
                                <template slot-scope="scope">
                                    <el-input size="small" v-if="scope.row.show && !dataForm.autoGenerate" v-model="scope.row.lichn" placeholder="生产批次"></el-input>
                                    <span v-else>{{scope.row.lichn}}</span>
                                </template>
                            </el-table-column>
                            <!-- 一键生成交货单专属列 Start -->
                            <el-table-column prop="expressCompany" header-align="center" align="left" label="快递公司" width="120" v-if="dataForm.autoGenerate">
                                <template slot="header" slot-scope="scope">
                                    <span style="color: red">*</span>快递公司
                                </template>
                                <template slot-scope="scope">
                                    <el-select size="small" v-model="scope.row.expressCompany" placeholder="选择快递公司" clearable filterable>
                                        <el-option
                                            v-for="item in expressCompanyList"
                                            :key="item.id || item.name"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="expressNo" header-align="center" align="left" label="快递单号" width="150" v-if="dataForm.autoGenerate">
                                <template slot="header" slot-scope="scope">
                                    <span style="color: red">*</span>快递单号
                                </template>
                                <template slot-scope="scope">
                                    <el-input size="small" v-model="scope.row.expressNo" placeholder="快递单号"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remainingStock" header-align="center" align="right" label="CRM剩余库存" width="100" v-if="dataForm.autoGenerate">
                                <template slot="header" slot-scope="scope">
                                    <span style="color: red">*</span>CRM剩余库存
                                </template>
                                <template slot-scope="scope">
                                    <ctl-number
                                        v-model="scope.row.remainingStock"
                                        placeholder="剩余库存">
                                    </ctl-number>
                                </template>
                            </el-table-column>
                            <el-table-column prop="zddnum" header-align="center" align="left" label="CRM订单号" width="120" v-if="dataForm.autoGenerate">
                            </el-table-column>
                            <el-table-column prop="zdditem" header-align="center" align="right" label="CRM订单行项号" width="100" v-if="dataForm.autoGenerate">
                            </el-table-column>
                            <!-- 一键生成交货单专属列 End -->
                            <el-table-column prop="werks" header-align="center" align="left" label="工厂" width="60">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.werks }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name2" header-align="center" align="left" label="工厂描述" width="150">
                                <template slot-scope="scope">
                                    <span>{{ getFactoryName(scope.row.werks) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="150">
                            </el-table-column>
                            <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="center" width="100" label="操作">
                                <template slot-scope="scope">
                                    <!-- <el-button type="text" size="small" @click="
                                        addOrUpdateDeliveryPartHandle(
                                            scope.row.id
                                        )
                                    " icon="el-icon-edit">
                                    修改
                                </el-button> -->
                                    <el-button plain v-if="(dataForm.asnStatus === '0' || dataForm.asnStatus === '3' || dataForm.asnStatus === '2') && !dataForm.autoGenerate" type="danger" size="mini" @click="
                                        deleteHandlePart(scope.row.id)
                                    " icon="el-icon-delete">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-table-edit>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
            </el-pagination>
        </el-tab-pane>
        <!-- <el-tab-pane :key="3" label="附件文件">
            <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
        </el-tab-pane> -->
    </el-tabs>
    <div v-if="isAuth('sourcing:delivery:newbutton') && viewFlag !== 'view'" style="text-align: right;">
        <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="viewData.visible = false">
                    关闭
                </el-button>
                <!-- 供应商 -->
                <template v-if="isAuth('sourcing:supplier:button') && ((dataForm.asnStatus === '0' || dataForm.asnStatus === '3' || dataForm.asnStatus === '2') || !dataForm.id) && viewFlag === 'edit'">
                    <el-button size="small" plain type="primary" @click="dataFormSave()">
                        保存
                    </el-button>
                    <el-button v-if="dataForm.id && dataForm.asnStatus != '2'" size="small" plain type="success" :loading="handleSaveLoading" @click="dataFormSubmit()">
                        提交审核
                    </el-button>
                </template>
                <!-- 生准物流 -->
                <template v-if="isAuth('sourcing:sgwl:button') && (dataForm.asnStatus === '1' && !dataForm.id)">
                    <el-button size="small" plain type="success" @click="dataFormPass()">
                        通过
                    </el-button>
                    <el-button v-if="dataForm.asnStatus ==='1' && !dataForm.id" size="small" plain type="danger" @click="dataFormReject()">
                        驳回
                    </el-button>
                    <!-- 内向交货单 -->
                    <el-button size="small" plain type="primary" @click="dataFormSync()">
                        同步SAP
                    </el-button>
                </template>
            </span>
    </div>

    <!-- 弹窗, 新增 / 修改 零件-->
    <add-or-update-delivery-part v-if="addOrUpdateDeliveryPartVisible" ref="addOrUpdateDeliveryPart" @refreshDeliveryPartDataList="getDeliveryPartList"></add-or-update-delivery-part>
    <select-order-part v-if="selectOrderPartVisible" :partFormData="dataForm" ref="selectOrderPart" @refreshDeliveryPartDataList="getDeliveryPartList"></select-order-part>
</el-dialog>
</template>

<script>
import Vue from 'vue'
import {
    getAddressList,
    getSupplierList
} from '@/controller/delivery'
import {getGroupListBySupplierCode,
  getSupCompanyList,} from '@/controller/order'
import {
    ASN_STATUS,
    DIALOG_CLOSED_TYPE,
    getAsnStatusByValue
} from "@/utils/const";
import {
    getDeliveryById,
    editDelivery,
    createDelivery,
    getDeliveryPartList,
    deletePartList,
    saveDeliveryPart,
    submitDelivery,
    saveDeliveryPartList
} from "@/controller/delivery";
import {
    getUnitList,
    getFactoryList,
    getApplianceTypeList,
    getExpressCompanyList
} from '@/controller/systemData'
// import FilesUpDown from "@/views/common/file-up-down";
import AddOrUpdateDeliveryPart from "./delivered-appart-add-or-update";
import SelectOrderPart from "./select-order-part"
import moment from 'moment'
require("@/mock/mockDelivery");
import CtlNumber from '@/views/common/ctl-number'
import { readFileSync, readFile, readSync } from 'fs';
export default {
    props: {
        partFormData: Object,
    },
    data() {
        return {
            subcompanyList: [],
            handleSaveLoading: false,
            show: false,
            FILE_BIZ_TYPE: 11,
            viewFlag: '',
            viewData: {
                visible: false,
                width: "",
            },
            ASN_STATUS: ASN_STATUS,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            getAsnStatusByValue: getAsnStatusByValue,
            dataList: [],
            unitList: [],
            factoryList: [],
            applianceTypeList: [],
            expressCompanyList: [],
            streetList: [],
            supplierList:[],
            groupList: [],
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            deviveryPartList: [],
            addOrUpdateDeliveryPartVisible: false,
            selectOrderPartVisible: false,
            createTime: '',
            lichnInfo: '',
            tabPanel:{},
            dataForm: {
                id: 0,
                asncode: '',
                supplierCode: '',
                supplierName: '',
                deliveryAddress: '',
                recieveyDate: '',
                deliveryDate: '',
                asnStatus: '',
                syncStatus: '',
                remark: '',
                deliveryId: '',
                groupCode: '',
                groupName: '',
                bukrs: '',
                subcompanyId:'',
                autoGenerate: false,
            },
            dataRule: {
                deliveryDate: [{
                    required: true,
                    message: "发货日期不能为空",
                    trigger: "blur",
                }, ],
                recieveyDate: [{
                    required: true,
                    message: "到货日期不能为空",
                    trigger: "blur"
                }],
                tenantName: [{
                    required: true,
                    message: "请先在页面顶部导航栏选择租户",
                    trigger: "blur",
                }, ],
                groupCode: [{
                    required: true,
                    message: "采购组不能为空",
                    trigger: "change",
                }, ],
            },
            recievePicker: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    },
    mounted() {},
    components: {
        AddOrUpdateDeliveryPart,
        SelectOrderPart,
        CtlNumber
        //FilesUpDown  附件上传
    },
    computed: {
        editTable() {
            return this.$refs.editTable
        }
    },
    methods: {
      // 计算送货箱数的方法
      calculateDeliveredBoxCount(row) {
        // 确保交货数量和收容数都存在且不为0
        if (row.lfimg && row.inCount && row.inCount !== 0) {
          // 向上取整计算送货箱数
          row.deliveredBoxCount = Math.ceil(row.lfimg / row.inCount);
          // 如果交货数量大于300，给出警告
          if (row.printFlag===1&&row.deliveredBoxCount > 300) {
            this.$message.warning("送货箱数超过300，请确认数据或拆分成多个交货单");
          }
        } else {
          row.deliveredBoxCount = null;
        }
      },
      getSubcompanyList() {
        this.subcompanyList = [];
        getSupCompanyList({}).then((data) => {
          if(data.body && data.body.length !== 0) {
            data.body.forEach((info) => {
              this.subcompanyList.push({
                value: info.value,
                label: info.label
              });
            });
          }
        });
      },
      // 子公司变更处理
      handleSubcompanyChange(val) {
        // 清空之前的选择
        this.dataForm.groupCode = '';
        this.dataForm.groupName = '';
        this.groupList = [];
        if (!val) {
          // 清空子公司时，重置相关字段
          this.dataForm.groupCode = '';
          this.dataForm.deliveryAddress = '';
          this.dataForm.subcompanyId='';
          return;
        }
        // 可以在这里添加根据子公司获取采购组和地址的逻辑
        this.getAddressList();
        this.getGroupList();
      },
      // 获取子公司名称（查看模式用）
      getSubcompanyName(value) {
        if (!value) return '';
        const company = this.subcompanyList.find(item => item.value === value);
        return company ? company.label : '';
      },
        getAddressListByCode() {
            this.getAddressList();
        },
        editAll() {
            this.deviveryPartList.map((i, index) => {
                i.show = true
                i.hsdat = i.hsdat ? i.hsdat : this.createTime
                i.vfdat = i.vfdat ? i.vfdat : this.createTime
                i.lichn = i.lichn ? i.lichn : this.lichnInfo
                // 初始化时也计算送货箱数
                this.calculateDeliveredBoxCount(i);
                Vue.set(this.deviveryPartList, index, i)
            })
        },
        handleSave() {
            if(!this.validateDeliveryPartList()) {
                return 
            }
            //调用保存方法
            this.saveData(this.deviveryPartList)
        },
        validateDeliveryPartList() {
            // 参数校验
            if (this.deviveryPartList.length === 0) {
                this.$message.error("请补充物料信息");
                return false;
            }
            for (var i in this.deviveryPartList) {
              // 检查交货数量是否大于300
              if (this.deviveryPartList[i].printFlag===1&&this.deviveryPartList[i].deliveredBoxCount > 300) {
                this.$message.error(`第${parseInt(i)+1}行的交货数量可能有误，请核对。如果交货箱数确定超过了300箱，请拆分成多个交货单生成`);
                return false;
              }
                if (!this.dataForm.autoGenerate) {
                    if (this.deviveryPartList[i].lfimg == '' || this.deviveryPartList[i].lfimg  == '0') {
                        this.$message.error("请补充交付数量");
                        return false;
                    }
                    if(this.deviveryPartList[i].boxType == '' || this.deviveryPartList[i].boxType == null) {
                        this.$message.error("请补充箱种")
                        return false;
                    }
                    if(this.deviveryPartList[i].inCount == '' || this.deviveryPartList[i].inCount == '0' || this.deviveryPartList[i].inCount == null) {
                        this.$message.error("请填写收容数")
                        return false;
                    }
                    // 送货箱数现在是自动计算的，只需要检查是否计算出有效值
                    this.calculateDeliveredBoxCount(this.deviveryPartList[i]);
                    if(this.deviveryPartList[i].deliveredBoxCount == '' || this.deviveryPartList[i].deliveredBoxCount =='0' || this.deviveryPartList[i].deliveredBoxCount == null) {
                        this.$message.error("送货箱数计算失败，请检查交货数量和收容数")
                        return false;
                    }
                    if(this.deviveryPartList[i].hsdat == '' || this.deviveryPartList[i].hsdat == null) {
                        this.$message.error("请填写生产日期")
                        return false;
                    }
                    if(this.deviveryPartList[i].lichn == '' || this.deviveryPartList[i].lichn == null) {
                        this.$message.error("请填写生产批次")
                        return false;
                    }
                }
                // 一键生成交货单：校验快递公司、快递单号、剩余库存
                if (this.dataForm.autoGenerate) {
                    if(this.deviveryPartList[i].expressCompany == '' || this.deviveryPartList[i].expressCompany == null) {
                        this.$message.error("请选择快递公司")
                        return false;
                    }
                    if(this.deviveryPartList[i].expressNo == '' || this.deviveryPartList[i].expressNo == null) {
                        this.$message.error("请填写快递单号")
                        return false;
                    }
                    if(this.deviveryPartList[i].remainingStock == '' || this.deviveryPartList[i].remainingStock == null) {
                        this.$message.error("请填写剩余库存")
                        return false;
                    }
                }
            }
            return true
        },
        saveData(list) {
            this.handleSaveLoading = true
            saveDeliveryPartList(
                list
            ).then(data => {
                if (data && data.code === '00') {
                    if(this.dataForm.syncStatus == '3' && this.dataForm.asnStatus == '2') {
                        this.dataForm.asnStatus = '0'
                    }
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                    })
                    if(this.dataForm.asnStatus == '0' || this.dataForm.asnStatus) {
                        this.$confirm('物料信息填写完毕, 是否提交审核?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.dataFormSubmit();
                        });
                    }
                    this.$emit("refreshDataList");
                    this.getDeliveryPartList()
                    this.handleSaveLoading = false
                } else {
                    this.handleSaveLoading = false
                  this.$confirm(data.msg, '错误', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'error'
                  });
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.handleSaveLoading = false
            })
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.deviveryPartList = [];
            this.viewData.visible = true;
            this.groupList = [];
            this.dataForm.groupCode = '';
            this.dataForm.groupName = '';
            if (data) {
                this.createTime = data.createTime;
            }
            this.$nextTick(() => {
                //初始化上传附件
                // this.$refs.FilesUpDown.init(id, this.FILE_BIZ_TYPE, null);
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找订单对象
                    getDeliveryById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm.innerCode = data.body.innerCode;
                            this.dataForm.asncode = data.body.asncode;
                            this.dataForm.supplierCode = data.body.supplierCode;
                            this.dataForm.supplierName = data.body.supplierName;
                            this.dataForm.deliveryAddress = data.body.deliveryAddress;
                            this.dataForm.recieveyDate = data.body.recieveyDate;
                            this.dataForm.deliveryDate = data.body.deliveryDate;
                            this.dataForm.asnStatus = data.body.asnStatus;
                            this.dataForm.syncStatus = data.body.syncStatus;
                            this.dataForm.remark = data.body.remark;
                            this.dataForm.groupCode = data.body.groupCode;
                            this.dataForm.groupName = data.body.groupName;
                            this.dataForm.bukrs=data.body.bukrs;
                            this.dataForm.subcompanyId=data.body.subcompanyId;
                            this.dataForm.autoGenerate=data.body.autoGenerate;
                        }
                    });
                    this.getDeliveryPartList();
                }
            });

            this.getUnitList();
            this.getFactoryList();
            this.getSupplierList();
            this.getGroupList();
            this.getSubcompanyList();
            this.getApplianceTypeList();
            this.getExpressCompanyList();
        },
        getApplianceTypeList() {
            getApplianceTypeList({}).then(data => {
                if (data && data.code === '00') {
                    this.applianceTypeList = data.body || [];
                }
            });
        },
        getExpressCompanyList() {
            getExpressCompanyList({}).then(data => {
                if (data && data.code === '00') {
                    this.expressCompanyList = data.body || [];
                }
            });
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getGroupList() {
            this.groupList = [];
            if (!this.dataForm.bukrs) {
              return;
            }
            getGroupListBySupplierCode({
              bukrs: this.dataForm.bukrs
            }).then((data) =>{
                if(data && data.code == '00') {
                  this.groupList = data.body.map(item => ({
                    label: item.label,
                    value: item.label  // 使用label作为value
                  }));
                }
                else {
                  this.groupList = [];
                }
            }).catch((e) => {
                console.log('获取采购组列表失败:',e)
              this.groupList = [];
            });
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.factoryDesc = ""
            })
        },
        getAddressList() {
          // 清空地址列表
          this.streetList = [];
          // 检查必要参数
          if (!this.dataForm.supplierCode && !this.dataForm.bukrs) {
            return;
          }
            getAddressList({
                "supplierCode": this.dataForm.supplierCode,
                "bukrs":this.dataForm.bukrs,
                street: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.streetList = data.body.body
                }
            })
        },
        getSupplierList() {
            getSupplierList({}).then(data => {
                if(data && data.code === '00') {
                    this.supplierList = data.body.body
                } else {
                  this.streetList = [];
                }
            }).catch(error => {
              console.error('获取地址列表失败:', error);
              this.streetList = [];
            });
        },
        setGroupName(val) {
            const group = this.groupList.find(group => group.value === val)
            return group ? group.label : ''
        },
        setFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.deliveryAddress = factory ? factory.address : ''
        },
        getFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            return factory ? factory.factoryDesc : ''
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        getTaxCodeName(code) {
            const taxCode = this.unitList.find(taxCode => taxCode.code === code)
            return taxCode ? taxCode.name : ''
        },
        selectPartList(id) {
            this.selectOrderPartVisible = true;
            this.$nextTick(() => {
                // const _this = this
                const ids = []
                const orderPartId = []
                this.deviveryPartList.forEach(part => {
                    ids.push(part.deliveryId)
                    orderPartId.push(part.orderPartId)
                });
                // this.$refs.selectOrderPart.open(ids);
                this.$refs.selectOrderPart.open(
                    this.dataForm.deliveryAddress, 
                    this.dataForm.id, 
                    this.dataForm.supplierCode,
                    this.dataForm.supplierName,
                    this.dataForm.groupCode,
                    orderPartId,
                    this.deviveryPartList,
                    this.dataForm.subcompanyId
                );
                this.$refs.selectOrderPart.onClosed = (payload) => {
                    if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                        if(this.dataForm.syncStatus == '3' && this.dataForm.asnStatus == '2') {
                            this.dataForm.asnStatus = '0'
                        }
                        this.getDeliveryPartList()
                    }
                };
            });
        },
        // 查所有订单零件表
        getDeliveryPartList() {
            if(this.dataForm.id == '') {
                return
            }
            getDeliveryPartList({
                deliveryId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.deviveryPartList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.deviveryPartList = [];
                    this.totalPage = 0
                }
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDeliveryPartList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDeliveryPartList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 新增 / 修改 零件表
        addOrUpdateDeliveryPartHandle(id) {
            this.addOrUpdateDeliveryPartVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateDeliveryPart.init(
                    id,
                    this.dataForm.id
                );
            });
        },
        // 删除零件
        deleteHandlePart(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePartList({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                if(this.dataForm.asnStatus == '2' && this.dataForm.syncStatus == '3') {
                                    this.dataForm.asnStatus = '0';
                                }
                                this.getDeliveryPartList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        dateFormatValue: function (value) {
            if (value == undefined) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // dateFormat: function (row, column) {
        //     var date = row[column.property]
        //     if (date == undefined) {
        //         return ''
        //     }
        //     return moment(date).format("YYYY-MM-DD前")
        // },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.handleSaveLoading = true
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '1',
                        'remark': this.dataForm.remark,
                        'groupCode': this.dataForm.groupCode,
                        'detail': this.deviveryPartList
                    };
                    if (this.dataForm.id) {
                        if(!this.validateDeliveryPartList()) {
                            this.handleSaveLoading = false
                            return
                        }
                        submitDelivery(deliveryParams).then((data) => {
                                if (data && data.code === "00") {
                                    this.dataForm.asnStatus = '1'
                                    this.viewData.visible = false;
                                    this.$emit("refreshDataList");
                                    this.handleSaveLoading = false
                                } else {
                                    this.handleSaveLoading = false
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                                this.handleSaveLoading = false
                            }).finally(() => {
                                this.handleSaveLoading = false
                            });
                    }
                }
            });
        },
        dataFormSave() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        // 'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'remark': this.dataForm.remark,
                        'groupCode': this.dataForm.groupCode,
                        'groupName': this.setGroupName(this.dataForm.groupCode),
                        'bukrs': this.dataForm.bukrs,
                    };
                    const tabIndex = this.$refs['tabPanel'].currentName;
                    if (this.dataForm.id) {
                        if(tabIndex == '0') {
                            // 根据id查找数据库里的交货单，如果采购组进行了修改，则提示“修改采购组后会清除已经选择的物料数据，是否确认修改？”
                            getDeliveryById({}, this.dataForm.id).then((data) => {
                                if (data && data.code === "00") {
                                    if(this.dataForm.groupCode != data.body.groupCode) {
                                        this.$confirm('修改采购组后会清除已经选择的物料数据，是否确认修改?', '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'warning'
                                        }).then(() => {
                                               editDelivery(deliveryParams).then((data) => {
                                                    if (data && data.code === "00") {
                                                        this.$message({
                                                            message: "保存成功",
                                                            type: "success",
                                                            duration: 1500,
                                                            onClose: () => {
                                                                this.$emit("refreshDataList");
                                                                this.getDeliveryPartList();
                                                            },
                                                        });
                                                        this.dataForm = data.body
                                                    } else {
                                                        this.$message.error(data.msg);
                                                    }
                                               }).catch((error) => {
                                                    console.log(error);
                                               });
                                        });
                                    } else {
                                        editDelivery(deliveryParams).then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "保存成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.$emit("refreshDataList");
                                                    },
                                                });
                                                this.dataForm = data.body
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        }).catch((error) => {
                                            console.log(error);
                                        });
                                    }
                                }
                            });
                        } else {
                            this.handleSave()
                        }
                    } else {
                        if(tabIndex == '0') {
                            createDelivery(deliveryParams).then((data) => {
                                if (data && data.code === "00") {
                                    this.dataForm = data.body
                                    this.$message({
                                        message: "ASN交货单创建成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            // this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            });
                        } else {
                            this.$message.error("请先保存基本信息")
                        }
                    }
                } else {
                    this.$message.error("请填写基本信息")
                }
            });
        },
        dataFormPass() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '2',
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        editDelivery(deliveryParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "邮件发送成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });

                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        dataFormReject() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let deliveryParams = {
                        id: this.dataForm.id || undefined,
                        'asncode': this.dataForm.asncode,
                        'supplierCode': this.dataForm.supplierCode,
                        'supplierName': this.dataForm.supplierName,
                        'deliveryAddress': this.dataForm.deliveryAddress,
                        'recieveyDate': this.dataForm.recieveyDate,
                        'deliveryDate': this.dataForm.deliveryDate,
                        'asnStatus': '3',
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        editDelivery(deliveryParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "邮件发送成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });

                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 640.5px;'
        }
    },
};
</script>

<style lang="scss" scoped>
.tab_style {
    min-height: 45vh;
}
</style>
